import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import "../login.css";
import axiosInstance from "../../../refershTokenManage/axiosConfig";
import CommonLoader from "../../../loader/CommonLoader";
import ReCAPTCHA from "react-google-recaptcha";

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    const email = searchParams.get("email");
    const token = searchParams.get("token");

    const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    const [formData, setFormData] = useState({
        password: "",
        password_confirmation: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({
        password: "",
        password_confirmation: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (fieldErrors[name]) {
            setFieldErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const handleRecaptchaChange = (token) => {
        setRecaptchaToken(token);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setFieldErrors({
            password: "",
            password_confirmation: ""
        });

        if (!email || !token) {
            setError("Invalid password reset request.");
            return;
        }

        if (formData.password.length < 6) {
            setFieldErrors(prev => ({
                ...prev,
                password: "Password must be at least 6 characters long."
            }));
            return;
        }

        if (formData.password !== formData.password_confirmation) {
            setFieldErrors(prev => ({
                ...prev,
                password_confirmation: "Passwords do not match!"
            }));
            return;
        }

        if (!recaptchaToken && process.env.REACT_APP_RECAPTCHA_ENABLED === 'true') {
            setError("Please complete the reCAPTCHA!");
            return;
        }

        setLoading(true);

        try {
            const response = await axiosInstance.post('/api/reset-password', {
                email,
                token,
                password: formData.password,
                password_confirmation: formData.password_confirmation,
                recaptchaToken
            });

            setSuccess("Password reset successful! Redirecting to login...");
            setTimeout(() => navigate("/sign-in"), 3000);
        } catch (error) {
            if (error.response?.data?.errors) {
                setFieldErrors(error.response.data.errors);
            } else {
                setError(error.response?.data?.error || "Failed to reset password. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main signInBackground">
            <div className="main__text-wrapper">
                <div className="form p-3 p-md-5">
                    <h4 className="mb-5 fs-2 fw-bold heading-color">
                        Enter Your New Password & Confirm Password
                    </h4>

                    <form className="forgot-password-form" onSubmit={handleSubmit}>
                        <div className="password mb-3">
                            <div className="input_password">
                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    placeholder="New Password"
                                    onChange={handleChange}
                                    required
                                    className={`loginFields ${fieldErrors.password ? 'error' : ''}`}
                                />
                                {fieldErrors.password && (
                                    <div className="field-error text-danger">
                                        {fieldErrors.password}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="password mb-3">
                            <div className="input_password">
                                <input
                                    type="password"
                                    name="password_confirmation"
                                    value={formData.password_confirmation}
                                    placeholder="Confirm Password"
                                    onChange={handleChange}
                                    required
                                    className={`loginFields ${fieldErrors.password_confirmation ? 'error' : ''}`}
                                />
                                {fieldErrors.password_confirmation && (
                                    <div className="field-error text-danger">
                                        {fieldErrors.password_confirmation}
                                    </div>
                                )}
                            </div>
                        </div>

                        {process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' && (
                            <div className="recaptcha-signin mb-3">
                                <ReCAPTCHA
                                    sitekey={RECAPTCHA_SITE_KEY}
                                    onChange={handleRecaptchaChange}
                                />
                            </div>
                        )}

                        {error && (
                            <div className="error-message text-danger fw-bold fs-6 text-center mb-3">
                                {error}
                            </div>
                        )}

                        {success && (
                            <div className="success-message text-success fw-bold fs-6 text-center mb-3">
                                {success}
                            </div>
                        )}

                        {loading && (
                            <div className="loader-overlay">
                                <CommonLoader />
                            </div>
                        )}

                        <button
                            type="submit"
                            className="submit"
                            disabled={loading}
                        >
                            Reset Password
                        </button>
                    </form>

                    <div className="newuser mt-3">
                        Remember your password?
                        <Link to="/sign-in" className="account ms-2">
                            Sign In
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
